










































import {
  defineComponent,
  ref,
  onMounted,
  getCurrentInstance,
} from '@vue/composition-api';
import LoadingPage from '@/components/loading-page';
import store from '@/store';
import { ubtPage } from '@/shared/utils/ubt';
import { setIosBouncesEable } from '@/api/native';
import NavBar from './components/NavBar/index.vue';
import AtmosphericHeader from './components/AtmosphericHeader/index.vue';
import CommonStaticRectangle from './components/CommonStaticRectangle/index.vue';
import CommonFixedRectangle from './components/CommonFixedRectangle/index.vue';
import { getActivityHomeConfig, assignAsync } from './service';
import type { ActivityHomeConfig } from './types';
import { ComponentTypeEnum } from './enums';
import { TP_ACTIVITY_HOME_PAGE_ID } from './tianqi';

export default defineComponent({
  name: 'ActivityHomeV3Component',
  components: {
    NavBar,
    AtmosphericHeader,
    CommonStaticRectangle,
    CommonFixedRectangle,
    LoadingPage,
  },
  setup() {
    const instance = getCurrentInstance();
    /** 页面配置 */
    const activityHomeConfig = ref<ActivityHomeConfig>({ orderComponents: [] });
    /** 加载状态 */
    const isLoading = ref<boolean>(true);
    /** url查询参数 */
    const routeQuery = instance?.proxy?.$route.query || {};
    /** ubt埋点通用参数 */
    const ubtCommonParams = ref<Dictionary>({
      ...routeQuery,
    });

    /**
     * 初始化页面数据
     */
    const initPageData = async () => {
      try {
        isLoading.value = true;

        await Promise.allSettled([
          assignAsync(
            activityHomeConfig,
            getActivityHomeConfig(routeQuery.activityType, store.state.base.isSupportWebp),
          ),
        ]);
      } finally {
        isLoading.value = false;
      }
    };

    onMounted(() => {
      initPageData();

      /** 设置ios弹性滚动禁止 */
      setIosBouncesEable(false);
      /** 自定义上报页面曝光埋点 */
      ubtPage(TP_ACTIVITY_HOME_PAGE_ID, '', Date.now(), undefined, ubtCommonParams.value);
    });

    return {
      activityHomeConfig,
      isLoading,
      ComponentTypeEnum,
      ubtCommonParams,
    };
  },
  /** 用户退出首页的行为 */
  beforeRouteLeave(to: any, from: any, next: any) {
    /** 退出页面 */
    next();
    /** 恢复ios弹性滚动 */
    setIosBouncesEable(true);
  },
});
